import styled from "styled-components"

export const Error = styled.span`
  color: #ff4136;
`

export const Center = styled.div`
  text-align: left;

  h4 {
    font-weight: normal;
  }
`

export const InputField = styled.div`
  position: relative;
  margin-bottom: 1rem;
`
export const Button = styled.button`
  cursor: pointer;
  border-radius: 3px;
  padding: 0.7rem 2.5rem;
  border: none;
  -webkit-appearance: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #fff;
  background: var(--clr-primary-3);

  &:focus {
    outline: none;
  }

  &:disabled {
    background: gray;
  }
`

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #2caeba;
  padding: 0.8rem 1rem;
  border-radius: 7px;
  margin-bottom: 0.5rem;
  transition: 0.3s;

  ${({ error }) =>
    error &&
    `
		border-color: #ff4136;
	`}

  &::placeholder {
    color: #a7a7a7;
  }
`
